(function () {
  const getYukoWidgetConfig = () => {
    return window?.Shopify?.yukoApp?.loyalty?.widgets
      ?.yuko_loyalty_product_widget;
  };

  // image content
  const getYukoWidgetImageContent = () => {
    let src = getYukoWidgetConfig()?.config?.message_icon?.url;
    if (!src) {
      return null;
    }
    let image = document.createElement("span");
    image.className = "yuko-loyalty-product-message-icon";
    image.setAttribute("role", "img");
    image.setAttribute("aria-label", "product message icon");
    image.style.cssText =
      "display:inline-block;width:20px;height:20px;background-color:currentColor;-webkit-mask:url('" +
      src +
      "') center/contain no-repeat;mask:url('" +
      src +
      "') center/contain no-repeat;";
    return image;
  };

  // message content
  const getYukoWidgetMessageContent = (earningValue, earningType) => {
    const container = document.createDocumentFragment();

    // Add image if available
    const imageElement = getYukoWidgetImageContent();
    if (imageElement) {
      container.appendChild(imageElement);
    }

    // Create and add message
    const earningTypeLabel = window.YukoUtil.getYukoLabel(
      earningType,
      earningValue
    );
    const pointsToCashRate = parseFloat(window?.Shopify?.yukoApp?.loyalty?.settings?.general_settings?.points_to_cash_rate) || 0.01;
    const cashValue = (earningValue * pointsToCashRate).toFixed(2);
    const cf = window.YukoThemeCurrencyUtils.getThemeCurrencyFormat('<span class="price-with-currency"> Rs. {{amount}} </span>');
    const formattedCashValue = window.YukoThemeCurrencyUtils.formatCurrency(cashValue, cf);
    const messageText = getYukoWidgetConfig()
      ?.config?.message?.replace(/\[points_value\]/g, earningValue)
      .replace(/\[points_label\]/g, earningTypeLabel)
      .replace(/\[points_cash_value\]/g, formattedCashValue);

    const messageElement = document.createElement("span");
    messageElement.className = "yuko-loyalty-product-message";
    messageElement.innerHTML = messageText;
    container.appendChild(messageElement);

    return container;
  };

  const applyYukoProductMessageStyles = (content) => {
    const styles = getYukoWidgetConfig()?.style || {
      border_color: "#000000",
      background_color: "#ffffff",
      text_color: "#000000",
      padding: 10,
      width: 100,
      height: null,
    };

    const productMessageElements = document.querySelectorAll(
      ".yuko-loyalty-product-content"
    );

    const paddingValue =
      styles.padding !== undefined && styles.padding !== null
        ? `${styles.padding}px`
        : "10px";
    const widthValue =
      styles.width !== undefined && styles.width !== null
        ? `${styles.width}%`
        : "100%";
    const heightValue =
      styles.height !== undefined && styles.height !== null
        ? `${styles.height}px`
        : "auto";

    productMessageElements.forEach(function (element) {
      const combinedStyles = `display: flex ; border: 1px solid ${styles.border_color} ; background-color: ${styles.background_color} ; color: ${styles.text_color} ; padding: ${paddingValue} ; width: ${widthValue} ; height: ${heightValue} ; align-items: center; border-radius: 8px; flex-direction: row; gap: 12px;`;

      // Clear existing content and append new content
      element.innerHTML = "";
      element.appendChild(content.cloneNode(true));
      element.setAttribute("style", combinedStyles);
    });
  };

  const handleYukoProductMessage = async (product) => {
    let customer = window?.Shopify?.yukoCustomer;

    // Prepare initial params to check if segments are needed
    let params = {
      product: product,
      calculate_based_on: "product",
      customer: customer,
      currency: window?.Shopify?.currency,
      store_currency_price:
        product?.price / window?.Shopify?.currency?.rate / 100,
    };

    // Only fetch customer segments if there are segment conditions
    /*if (window.YukoUtil.needsCustomerSegments(params)) {
            customer = await window.YukoUtil.enrichCustomerWithSegments(customer);
            params.customer = customer;
        }*/

    let earning = window?.yukoCalculation?.calculate(params);

    const editorMode = isEditorMode();
    if (
      earning === null ||
      earning === undefined ||
      (!editorMode && earning?.earning_value === 0)
    ) {
      return;
    }

    let earningValue = earning?.earning_value || 0;
    let earningType = earning?.earning_type || "";
    let message = getYukoWidgetMessageContent(earningValue, earningType);
    applyYukoProductMessageStyles(message);
  };

  const hideYukoProductMessage = () => {
    const elements = document.querySelectorAll(".yuko-loyalty-product-content");
    elements.forEach((el) => {
      const parent = el?.parentElement;
      const shouldHide =
        parent &&
        (parent.classList.contains("shopify-block") ||
          parent.classList.contains("shopify-app-block") ||
          parent.getAttribute("data-block-handle") ===
            "reviews-yuko-embed-assets");
      if (shouldHide) {
        parent.style.display = "none";
      }
      el.style.display = "none";
    });
  };
  function isEditorMode() {
    try {
      return !!(window?.Shopify && window.Shopify.designMode);
    } catch (e) {
      return false;
    }
  }

  // Auto-initialize if earn is enabled
  document.addEventListener("DOMContentLoaded", function () {
    const editorMode = isEditorMode();

    if (!editorMode) {
      if (window?.Shopify?.yukoApp?.features?.loyalty === false) {
        return;
      }
      if (!getYukoWidgetConfig()?.is_enabled) {
        return;
      }
    }

    if (window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        handleYukoProductMessage(e.data.variant);
      });
    }
    handleYukoProductMessage(window?.Shopify?.yukoProduct);
  });
})();
